import React from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import AdvanceTableWrapper from "../../components/common/advance-table/AdvanceTableWrapper";
import {Card} from "react-bootstrap";
import AdvanceTable from "../../components/common/advance-table/AdvanceTable";
import {LinkCell} from "../../components/common/advance-table/CustomCells";
import IndexTableHeader from "../../components/common/headers/IndexTableHeader";
import AdvanceTableFooter from "../../components/common/advance-table/AdvanceTableFooter";

const cols = [
    {
        accessor: 'name',
        Header: 'Name',
        cellProps: {className: 'py-2'},
        Cell: rowData => {
            const {name, id} = rowData.row.original;
            return <LinkCell name={name} to={"/billing-groups/" + id}/>;
        }
    },
    {
        accessor: "tin",
        Header: "TIN",
        filter: "includes"
    },
];

const ContractBillingGroups = ({billingGroups}) => {
    const data = useFragment(graphql`
        fragment ContractBillingGroups_BillingGroups on BillingGroup @relay(plural: true) {
                id
                name
                identifiers {
                        identifierType {
                            code
                        }
                        value
                }
        }
    `, billingGroups);

    const mappedData = data.map(d => ({
        ...d,
        tin: Array.from(new Set(d.identifiers?.filter(x => x.identifierType.code === "TIN").map(y => {return y.value}))).toSorted().join(", ") 
    }));

    return (
        <>
            <AdvanceTableWrapper
                columns={cols}
                data={mappedData}
                sortable
                pagination
                perPage={10}
                initialSortColumn="name"
            >
                <Card className="mb-3">
                    <Card.Header>
                        <IndexTableHeader
                            name={"Billing Groups"}
                            table
                            showNew={false}
                            onNewClick={() => {
                            }}
                        />
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                className: 'fs--1 mb-0 overflow-hidden'
                            }}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter
                            table
                            rowInfo
                            rowCount={billingGroups.length}
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
        </>
    );
};

export default ContractBillingGroups;